import React, { useState } from 'react';
import { 
  Globe, 
  BookOpen, 
  Target, 
  FileText, 
  Tag, 
  BarChart3
} from 'lucide-react';
import AdminLayout from '../../components/admin/AdminLayout';
import DomainManagement from '../../components/admin/learning/DomainManagement';
import SubjectManagement from '../../components/admin/learning/SubjectManagement';
import KnowledgePointManagement from '../../components/admin/learning/KnowledgePointManagement';
import ArticleManagement from '../../components/admin/learning/ArticleManagement';
import TagManagement from '../../components/admin/learning/TagManagement';

const LearningManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState('domains');

  const tabs = [
    { id: 'domains', name: '领域管理', icon: Globe },
    { id: 'subjects', name: '学科管理', icon: BookOpen },
    { id: 'knowledge-points', name: '知识点管理', icon: Target },
    { id: 'articles', name: '文章管理', icon: FileText },
    { id: 'tags', name: '标签管理', icon: Tag },
    { id: 'statistics', name: '统计分析', icon: BarChart3 }
  ];



  const renderTabContent = () => {
    switch (activeTab) {
      case 'domains':
        return <DomainManagement />;
      case 'subjects':
        return <SubjectManagement />;
      case 'knowledge-points':
        return <KnowledgePointManagement />;
      case 'articles':
        return <ArticleManagement />;
      case 'tags':
        return <TagManagement />;
      case 'statistics':
        return (
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-lg font-semibold mb-4">统计分析</h3>
            <p className="text-gray-500">统计分析功能开发中...</p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <AdminLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* 页面标题 */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">学习模块管理</h1>
          <p className="text-gray-600">管理教育内容的层级结构和学习资源</p>
        </div>



        {/* 标签导航 */}
        <div className="bg-white rounded-lg shadow mb-6">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8 px-6">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center py-4 px-1 border-b-2 font-medium text-sm ${
                      activeTab === tab.id
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <Icon className="w-5 h-5 mr-2" />
                    {tab.name}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* 标签内容 */}
        {renderTabContent()}
      </div>
    </AdminLayout>
  );
};

export default LearningManagement;